import services from './../../../services/service'; // Service Class
//import AccountResources from './../../Account/Resources/commonfunctions.js';

import MainScript from './../../ManageItems/main.js'
//
import DesktopHeaderPanel from './../../DesktopViews/HeaderPanel.vue'

//
let service = new services();

export default {
    name: 'ManageOrders',
    mixins: [MainScript],
    data () {
        return {
            headerdata:{'name':this.$route.name},
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",
            //
            headerdata:{
                'name':'Set Order',
            },

            //
            reset_order:false,
            set_in_view:'',
            set_inner_view:'',
            set_tab_inner_view:{},
            item_view: 0, //default
        }
    },
    components: {
        'desktop-header-panel': DesktopHeaderPanel
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        preset() {
            this.loading = true;
            
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    //self.setProduct();
                    localforage.getItem(service.bdb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                            self.sellpoint = value;
                            //
                            self.setPageSettings();
                            //get some core details
                            self.setBusinessDetails();
                            //get products
                            self.getSellpointProducts();
                        }else{
                            self.loading = false;
                            self.getSellpoints(self.user.user_id);
                        }
                    });
                }else {
                    self.loading = false;
                    self.$router.push('/login')
                }
            });
            
        },

        setPageSettings(){
            //--set views
            this.setItemViewStyles();
            this.getMainCategories(this.sellpoint.business_category_id);
        },

        prepSetCategoryView(set_category){
            this.category = set_category;
            this.setMenuTabInnerView('viewCategory');
            if(this.site_view == 14){//mobile
                //
                if(this.menu_tab_inner_view['addNewCategory']){
                    let self = this;
                    this.setMenuTabInnerView('');
                    setTimeout(function(){  
                        document.getElementById("categoryList").style.display = "none";
                        document.getElementById("categoryView").style.display = "block";
                    }, 1000); //wait for 1min and timeout
                    //this.setMenuTabInnerView('');
                }else{
                    this.toggleDoubleComponent("categoryList","categoryView");
                }
            }
        },

        setItemView(view){
            this.item_view = view;
            this.setItemViewStyles();
        },

        setItemViewStyles(){
            //--set views
            
            var itemsView = document.getElementById("itemsView");
            var regularItemsView = document.getElementById("regularItemsView");
            var categoriesView = document.getElementById("categoriesView");

            if((itemsView != null) && (regularItemsView != null) && (categoriesView != null)){
                //---temp-resets
                regularItemsView.style.color = "#000000";
                categoriesView.style.color = "#000000";
                itemsView.style.color = "#000000";
                //
                itemsView.style.borderBottomColor = "#ffffff";
                regularItemsView.style.borderBottomColor = "#ffffff";
                categoriesView.style.borderBottomColor = "#ffffff";
                //---./
                
                if(this.item_view == 1){
                    regularItemsView.style.color = "#ff0000";
                    regularItemsView.style.borderBottomColor = "#ff0000";
                }else if(this.item_view == 2){
                    categoriesView.style.color = "#ff0000";
                    categoriesView.style.borderBottomColor = "#ff0000";
                }else{
                    itemsView.style.color = "#ff0000";
                    itemsView.style.borderBottomColor = "#ff0000";
                }
            }
        },

        setBusinessDetails(){
            //---bank-details
            let self = this;
            localforage.getItem(service.bbnksdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });
            //--delivery-locations
            localforage.getItem(service.bbdlsdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            ///get/reset business-----set func at common...
            this.getSellpointDetails(this.sellpoint.business_username);
            ///--business
            ///banks
            //delivery locations
        },

        setAddNew(mod,type){
            if(type == 1){//main item
            }else if(type == 2){//regular item
                this.set_product_is_addon=1;
            }
            //
            if(mod == 1){//product
                this.product={}; //re-ini
                //
                this.set_back_nav.view_type = 2;
                this.set_back_nav.view_src = '';
                //
                this.setMenuTabInnerView('addProduct')
                this.$router.push("/manage/items/add");
            }else if(mod == 2){//category
                this.category={};
                this.setMenuTabInnerView('addNewCategory')
                this.$router.push("/manage/items/add/category");
            }
            //
            this.set_show_header = false;
        },

        setToView(view){
            this.setMenuTabInnerView(view);
            if(view == ''){
                if(this.$route.path != "/manage/items"){
                    this.$router.push("/manage/items");
                }
                //
                this.set_show_header = true;
            }else{
                //
                this.set_show_header = false;
            }
        },

        // setToView(view){
        //     this.setMenuTabInnerView(view);
        //     if(view == ''){
        //         if(this.$route.path != "/manage/items"){
        //             this.$router.push("/manage/items");
        //         }
        //         //
        //         this.set_show_header = true;
        //     }else{
        //         //
        //         this.set_show_header = false;
        //     }
        // },

        setTabInnerView(view){
            //--with toggle effect
            if(this.set_tab_inner_view[view]){
                this.set_tab_inner_view[view] = false;
                this.set_tab_inner_view = {};
            }else{
                this.set_tab_inner_view = {};
                this.set_tab_inner_view[view] = true;
            }
        },

        setOrderOptionView(view){
            this.setTabInnerView(view); 
            if(this.site_view == 1){
                this.jumpToView('jumpToSetOrderOptions');
            }
        },

    },
    created: function(){
        //some default
        this.callBackNav();
        //
        if(this.$route.path == "/manage/items/add"){
            this.setMenuTabInnerView('addProduct');
        }else if(this.$route.path == "/manage/items/add/category"){
            this.setAddNew(2,3)
        }else if(this.$route.path == "/manage/items/available"){
            this.set_in_view = 'available_items';
            this.setMenuTabInnerView('availableItems');
        }else if(this.$route.path == "/manage/items/regular"){
            this.item_view = 1;
            this.setItemView(1);
        }else if(this.$route.path == "/manage/items/categories"){
            this.item_view = 2;
            this.setItemView(2);
        }else{
            this.item_view = 0;
            this.setItemView(0);
            this.setMenuTabInnerView('');
        }
        //
        this.setScreenView();
        this.preset();
    }
}



// WEBPACK FOOTER //
// ./src/pages/Components/ItemsManagement/script.js